import React, { useMemo } from "react";
import { QuickPickProps } from "../types";
import { MarketButton } from "../../MarketButton/MarketButton";
import { Button } from "components/src/components/Button/Button";
import { QuickPickLegs } from "./QuickPickLegs";
import kebabCase from "lodash-es/kebabCase";
import { computeLegs } from "../helpers/computeLegs";

export function Minimal({
  legs = [],
  onClick = () => {},
  price,
  title,
  disabled = false,
  selected = false,
  badge = "qp",
  showBadge,
  id,
  isEditable = false,
  onEditClick
}: Partial<QuickPickProps> & { isEditable?: boolean }) {
  const computedLegs = useMemo(
    () => computeLegs({ badge, title, showBadge, legs }),
    [badge, title, showBadge, legs]
  );

  const _computedLegs = [computedLegs?.titleLeg, ...computedLegs.legs]
  return (
    <div
      className="cui-w-auto cui-flex cui-items-center cui-justify-between cui-gap-lg"
      role="presentation"
      data-cy="quick-pick"
    >
      <div className="cui-w-3/4" role="group">
        <QuickPickLegs computedLegs={_computedLegs} />
      </div>
      <div className="cui-flex cui-flex-col cui-gap-xs cui-items-center">
        <div className="cui-min-w-[44px] md:cui-min-w-[132px] cui-max-w-[132px] cui-w-full">
          <MarketButton
            id={`${id}-market-button`}
            variant="highlight"
            odds={price}
            onClick={(e) => onClick(legs, e)}
            isSelected={selected}
            isDisabled={disabled}
            fluid={true}
            animation="off"
          />
        </div>
        {isEditable && (
          <Button
            type="minimal"
            size="sm"
            leftIcon={{ name: "icon_ui_pencil", size: "sm" }}
            onClick={() => onEditClick?.(id)}
          >
            Edit
          </Button>
        )}
      </div>
    </div>
  );
}
